const captionDefaultAttributes = {
  styleDefaults: {
    paddingTop: "16px",
    paddingBottom: "16px"
  },
  textStyle: {
    textAlignment: "CENTER",
    lineHeight: 1.5
  }
};
export {
  captionDefaultAttributes
};
//# sourceMappingURL=consts.js.map
